import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
export default function Redirect_mytask() {
   const navigate = useNavigate();
    
      useEffect(() => {
        navigate('/my_task'); 
      }, [navigate]); 
    
      return null; 
}
